export const editorGlobal: string = `
  /* Class selector needed because "Convert to Text" strips data-case-detail-table but keeps the class */
  div[data-case-detail-table] table,
  div[class*="caseDetailTable"] table {
    border-collapse: collapse !important;
    width: 100% !important;
  }

  div[data-case-detail-table] table td,
  div[class*="caseDetailTable"] table td {
    width: 50% !important;
    text-align: center !important;
  }

  div[data-case-detail-table] table td,
  div[data-case-detail-table] table,
  div[class*="caseDetailTable"] table td,
  div[class*="caseDetailTable"] table {
    border: 1px dashed #bbb;
  }
`

export default editorGlobal
